import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <MediaSection />
        <CommentsSection />
        <UpdatesSection />
        <TopicsSection />
        <IndexSection />
        <FaqSection />
        <AboutSection />
        <FeaturesSection />
        <CarouselSection />
        <CardsSection />
        <AppSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}